export const Songs="Songs"

export const songsaction=(data)=>{
    return {type:Songs,payload:data}
}